/** Allowed HTML tags when sanitizing note bodies for persist/display. */
export const NOTE_HTML_ALLOWED_TAGS = [
    'p',
    'br',
    'strong',
    'em',
    'u',
    's',
    'a',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'pre',
    'code',
    'hr',
    'img',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'div',
    'span',
    'mark',
    'details',
    'summary',
    'input',
    'label',
];
/** Persisted note HTML attributes (`style` excluded — CSS injection risk). */
export const NOTE_HTML_ALLOWED_ATTR = [
    'href',
    'target',
    'rel',
    'src',
    'alt',
    'class',
    'data-callout',
    'data-callout-variant',
    'data-note-color',
    'data-note-bg',
    'data-type',
    'data-checked',
    'type',
    'checked',
    'disabled',
];
export const NOTE_FORBID_TAGS = ['svg', 'math', 'iframe', 'object', 'embed', 'form', 'script', 'style'];
export const MAX_NOTE_TITLE_CHARS = 500;
export const MAX_NOTES_CIPHER_BYTES = 700 * 1024;
export const GLOBAL_MAX_NOTE_BODY_BYTES = 512 * 1024;
export const NOTE_MEDIA_STORAGE_BYTES = {
    free: 0,
    pro: 200 * 1024 * 1024,
    team: 512 * 1024 * 1024,
    business: 2 * 1024 ** 3,
};
export const MAX_NOTE_BODY_BYTES = {
    free: 64 * 1024,
    pro: 192 * 1024,
    team: 256 * 1024,
    business: 384 * 1024,
};
